var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import MFPlaceOrderTable from "./MutualFund/MFPlaceOrderTable";
import { generatePageHeaderName } from "@frameworks/salesjourney/components/Generic/TransparentHeader/TransparentHeader";
import GenericTabs from "@frameworks/shared-library/components/GenericTabs";
import "@frameworks/salesjourney/stylesheets/components/Features/PlaceOrder/PlaceOrder.scss";
import Errormsg from "@frameworks/shared-library/components/errorMsg";
import openBoxHourGlass from "@frameworks/shared-library/assets/images/SalesJourney/openBoxHourGlass.svg";
import { ESubProductNames, ESubProductIds, } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
import { useLocation } from "react-router-dom";
var placeOrderTabsItems = [
    { title: "Mutual Fund", eventKey: ESubProductNames.MutualFund },
    { title: "IPO", eventKey: ESubProductNames.IPO },
    { title: "NFO", eventKey: ESubProductNames.NFO },
    { title: "Primary NCD", eventKey: ESubProductNames.NCD },
];
var leadRedirectionState = {
    categoryCode: "",
};
var generateComingSoonComponent = function () {
    return (React.createElement("div", { className: "custom-error-state" },
        React.createElement(Errormsg, { image: openBoxHourGlass, msg: " ", customComp: React.createElement("div", { className: "d-flex align-content-center" },
                React.createElement("p", { className: "DMSansMedium_18_500 txt_grey-shadeone text-center" },
                    "New and Improved order forms are ",
                    React.createElement("br", null),
                    " coming soon. Stay! tuned")) })));
};
var placeOrderTabs = [
    {
        title: "Mutual Fund",
        eventKey: ESubProductIds.MutualFund,
        tabContent: React.createElement(MFPlaceOrderTable, null),
    },
    {
        title: "IPO",
        eventKey: ESubProductIds.IPO,
        tabContent: generateComingSoonComponent(),
    },
    {
        title: "NFO",
        eventKey: ESubProductIds.NFO,
        tabContent: generateComingSoonComponent(),
    },
    {
        title: "Primary NCD",
        eventKey: ESubProductIds.NCD,
        tabContent: generateComingSoonComponent(),
    },
];
var PlaceOrder = function (props) {
    var _a;
    var _b = __read(useState(""), 2), currentSelectedTransactionsTab = _b[0], setCurrentSelectedTransactionsTab = _b[1];
    var location = useLocation();
    var params = new URLSearchParams(location.search);
    leadRedirectionState.categoryCode = params.get("categoryCode");
    var categoryCode = (leadRedirectionState === null || leadRedirectionState === void 0 ? void 0 : leadRedirectionState.categoryCode) ||
        ((_a = location === null || location === void 0 ? void 0 : location.state) === null || _a === void 0 ? void 0 : _a.categoryCode) ||
        ESubProductIds.MutualFund;
    var handleTabChange = function (selectedTab) {
        setCurrentSelectedTransactionsTab(selectedTab);
    };
    useEffect(function () {
        setCurrentSelectedTransactionsTab(categoryCode);
    }, [categoryCode]);
    useEffect(function () {
        !!props.setHeaderLeftComponent &&
            props.setHeaderLeftComponent(React.createElement("div", { className: "d-flex align-items-center gap-4" }, generatePageHeaderName("Place Order")));
    }, []);
    return (React.createElement("div", { className: "primary-place-order-container" },
        React.createElement(GenericTabs, { defaultActiveKey: currentSelectedTransactionsTab, tabsArray: placeOrderTabs, callBackFunction: handleTabChange, externalClassName: "d-flex flex-column w-100\n        " })));
};
export default PlaceOrder;
